<template>
  <a-card :body-style="{padding: '24px 32px'}" :bordered="false">
    <a-form @submit="handleSubmit" :form="form">
      <a-form-item label="账户：" :labelCol="{lg: {span: 4}, sm: {span: 4}}" :wrapperCol="{lg: {span: 16}, sm: {span: 16} }">
      <span class="ant-form-text">
        {{ username() }}
      </span>
      </a-form-item>
      <a-form-item label="昵称：" :labelCol="{lg: {span: 4}, sm: {span: 4}}" :wrapperCol="{lg: {span: 16}, sm: {span: 16} }">
      <span class="ant-form-text">
        {{ nickname() }}
      </span>
      </a-form-item>
      <a-form-item
        label="原密码"
        :labelCol="{lg: {span: 4}, sm: {span: 4}}"
        :wrapperCol="{lg: {span: 8}, sm: {span: 8} }"
      >
        <a-input
          placeholder="请输入旧密码"
          type="password"
          autocomplete="false"
          v-decorator="[
              'originalpassword',
              {rules: [{ required: true, message: '请输入旧密码' }], validateTrigger: 'blur'}
            ]"/>
      </a-form-item>
      <a-form-item
        label="新密码"
        :labelCol="{lg: {span: 4}, sm: {span: 4}}"
        :wrapperCol="{lg: {span: 8}, sm: {span: 8} }"
      >
        <a-input
          placeholder="请输入新密码"
          type="password"
          autocomplete="false"
              v-decorator="[
              'password',
              {rules: [{ required: true, message: '请输入新密码' }], validateTrigger: 'blur'}
            ]"/>
      </a-form-item>
      <a-form-item
        label="确认密码"
        :labelCol="{lg: {span: 4}, sm: {span: 4}}"
        :wrapperCol="{lg: {span: 8}, sm: {span: 8} }"
      >
        <a-input
          placeholder="请再次输入新密码"
          type="password"
          autocomplete="false"
          v-decorator="[
              'confirmpassword',
              {rules: [{ required: true, message: '请再次输入新密码' }], validateTrigger: 'blur'}
            ]"
        />
      </a-form-item>
      <a-form-item
        :wrapperCol="{ span: 24 }"
        style="text-align: center"
      >
        <a-button htmlType="submit" type="primary" :loading="state.loginBtn" :disabled="state.loginBtn">提交</a-button>

      </a-form-item>
    </a-form>
  </a-card>
</template>
<script>
import { mapGetters } from 'vuex'
import { modifyPassword } from '@/api/profile'
import { CODE_FAIL } from '@/store/mutation-types'
export default {
  name: 'UserProfilePassword',
  components: {},
  data () {
    return {
      loginBtn: false,
      form: this.$form.createForm(this),
      state: {
        loginBtn: false
      }
    }
  },
  methods: {
    ...mapGetters(['username', 'nickname']),
    // handler
    handleSubmit (e) {
      e.preventDefault()
      const {
        form: { validateFields },
        state
      } = this
      state.loginBtn = true
      validateFields(['originalpassword', 'password', 'confirmpassword'], { force: true }, (err, values) => {
        console.log(values)
        if (!err) {
          const formParams = { ...values }
          formParams.password = values.password
          formParams.confirmpassword = values.confirmpassword

          modifyPassword(formParams)
            .then((res) => this.requestSuccess(res))
            .catch(err => this.requestFailed(err))
            .finally(() => {
              state.loginBtn = false
            })
        } else {
          setTimeout(() => {
            state.loginBtn = false
          }, 600)
        }
      })
    },
    requestSuccess (res) {
      if (res.status !== CODE_FAIL) {
        this.$message.success('修改密码成功')
      } else {
        this.$message.error(res.message)
      }
    },
    requestFailed (err) {
      this.$notification['error']({
        message: '错误',
        description: ((err.response || {}).data || {}).message || '请求出现错误，请稍后再试',
        duration: 4
      })
    }
  }
}
</script>
